import { render, staticRenderFns } from "./ProductionTasks.vue?vue&type=template&id=536d90ce"
import script from "./ProductionTasks.vue?vue&type=script&lang=js"
export * from "./ProductionTasks.vue?vue&type=script&lang=js"
import style0 from "./ProductionTasks.vue?vue&type=style&index=0&id=536d90ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports